import React, { useState } from "react";
import { Box } from "@mui/material";
import { Text } from "@imminently/react/ui/core/text";
import { PatientEncounter, Photo } from "@/resources/types";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { css } from "@/theme";

const styles = {
  container: css`
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    border-radius: 8px;
    border: 1px solid  #C3C8DE;
    background: #FFF;
  `,
  photosContainer: css`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
  `,
};

type ImageProps = {
  photo: Photo;
  onSelect: () => void;
}
const Image = ({ photo, onSelect }: ImageProps) => {
  return (
    <img key={photo.data} style={{
      borderRadius: 8,
      cursor: "pointer"
    }} width={80} height={80} src={photo.data} onClick={onSelect} />
  );
};

interface PresentingProblemsProps {
  encounter: PatientEncounter;
  problemPhotos?: Photo[];
}
export const PresentingProblems = ({ encounter, problemPhotos }: PresentingProblemsProps) => {
  const [
    selectedImage,
    setSelectedImage,
  ] = useState<number | undefined>(undefined);

  const selectedImageIndex = selectedImage;
  const slides = problemPhotos?.map(photo => ({
    src: photo.data,
    width: 640,
    height: 640
  }));

  return (
    <Box css={styles.container}>
      <Text variant="body1">
        {encounter.problem.patient}
      </Text>

      <Box css={styles.photosContainer}>
        {problemPhotos?.length ? <>
          {problemPhotos.map((photo, index) => (
            <Image key={`${index}-${photo.data}`} onSelect={() => setSelectedImage(index)} photo={photo} />
          ))}
        </> : null}
      </Box>

      <Lightbox
        styles={{
          container: {
            background: "rgba(0,0,0,0.5)"
          },
        }}
        index={selectedImageIndex}
        carousel={{
          finite: true,
          imageFit: "cover"
        }}
        open={typeof selectedImage === "number"}
        close={() => { setSelectedImage(undefined); }}
        slides={slides}
      />

    </Box>);
};